import React from "react";

import { Box } from "@mui/material/";
import Mailbox from "../../../Mensajes/Mailbox";

const MessagesTab = ({ dataCase }) => {
  return (
    <Box sx={{ display: "flex", gap: 3, width: "100%" }}>
      <Mailbox
        dataCase={dataCase || {}}
        heighProp={"800px"}
        insideCase={true}
      />
    </Box>
  );
};

export default MessagesTab;
